<template>

  <label class="checkbox" :class="{ disabled: disabled }" @click="change()">
    <span class="checkmark" :class="{ checked: value }"/>
    <div v-if="hasSlot" class="span-slot">
      <slot/>
    </div>
  </label>

</template>

<script>
  export default {
    computed: {
      hasSlot() {
        return this.$slots.default
      }
    },
    data: function() {
      return {
        checked: this.value
      };
    },
    methods: {
      change() {
        if (this.disabled)
          return

        this.checked = !this.checked;
        this.$emit('input', this.checked);
      }
    },
    name: 'BkpsCheckBox',
    props: {
      disabled: { default: false },
      value: { required: true}
    },
    watch: {
      value(newValue) {
        // para alterar modificações não feito diretament no componente
        if (newValue !== this.checked)
          this.checked = newValue
      }
    }
  }
</script>

<style scoped lang="scss">

  .checkbox {
    display: inline-block;
    box-sizing: border-box;
    position: relative;
    // ponytail: o .checkmark é absolute, sem slot o label ficava com 0 de largura
    // e o texto ao lado subia por cima dele
    flex: none;
    min-width: 16px;
    min-height: 16px;
    margin-bottom: 8px;
    padding-bottom: 8px;
    margin-top: 0px;
    cursor: pointer;
    .checkmark {
      &:after {
        left: 4px;
        top: 1px;
        width: 4px;
        height: 8px;
        border: solid white;
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }
    }

    .checked {
      background-color: var(--primary-text-color);
      &:after {
        display: block;
      }
    }
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 16px;
    width: 16px;
    background-color: transparent;
    border: solid 2px var(--primary-text-color);
    border-radius: 20%;
    &:after {
      content: "";
      position: absolute;
      display: none;
    }
  }

  .span-slot {
    margin-left: 16px;
  }

  .disabled {
    cursor: not-allowed;
  }

</style>
